import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const fields = sqliteTable('fields', {
  id: text('id').notNull().primaryKey(),
  laravel_id: integer('laravel_id'),
  user_id: integer('user_id'),
  name: text('name').notNull(),
  slug: text('slug').notNull(),
  type: text('type').notNull(),
  module: text('module').notNull(),
  /** JSON-encoded array of pick-list options; empty/irrelevant for other field types. */
  options: text('options').notNull(),
  is_enabled: integer('is_enabled'),
  organization_id: text('organization_id'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
});

export const field_values = sqliteTable('field_values', {
  id: text('id').notNull().primaryKey(),
  laravel_id: integer('laravel_id'),
  field_id: integer('field_id'),
  field_uuid: text('field_uuid').references(() => fields.id),
  /** Points at a row in whatever table `fields.module` names (expenses, costs, tasks, ...) — there
   * is no type column here because the owning module is already known via the field. */
  record_id: integer('record_id'),
  record_uuid: text('record_uuid'),
  value: text('value').notNull(),
  is_enabled: integer('is_enabled'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
});
